import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Navbar from "./Navbar";
import Contact from "./Contact";
import Footer from "./Footer";

export default function DetailsPage({ title, image, sections = [] }) {
  return (
    <>
      <Navbar />
      <section className="section bg-light" style={{ minHeight: "80vh" }}>
        <Container>
          <Row className="justify-content-center mb-4">
            <Col lg={10}>
              <Card className="shadow rounded overflow-hidden border-0">
                <Row className="g-0 align-items-center">
                  {image && (
                    <Col md={5} className="p-0 d-none d-md-block">
                      <img
                        src={image}
                        className="img-fluid w-100 h-100 object-fit-cover"
                        alt={title}
                        style={{ minHeight: 320, objectFit: "cover" }}
                      />
                    </Col>
                  )}
                  <Col md={image ? 7 : 12} className="p-0">
                    <CardBody className="content p-4">
                      <h2 className="title text-dark mb-4">{title}</h2>
                      {sections.map((section, idx) => (
                        <div className="mb-4" key={idx}>
                          <h5 className="mb-2 text-numantra-primary">
                            {section.heading}
                          </h5>
                          {Array.isArray(section.content) ? (
                            <ul>
                              {section.content.map((item, i) => (
                                <li key={i}>{item}</li>
                              ))}
                            </ul>
                          ) : (
                            <p className="text-muted mb-0">{section.content}</p>
                          )}
                        </div>
                      ))}
                    </CardBody>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Contact />
      <Footer />
    </>
  );
}
